import React from "react";

export default function ChartPanel(props) {
    return (
        <div className="resumen-panel">
            <div className="resumen-panel-header">
                <span className="resumen-panel-title">{props.title}</span>
            </div>
            {props.children}
        </div>
    );
}
